import React from "react";
import "./CanvaMark.scss";

type Props = {
  size?: number;
  className?: string;
};

/** Inline Canva-style round mark (gradient + C). Decorative; pair with aria-label on the control. */
export const CanvaMark = ({ size = 44, className = "" }: Props) => (
  <span
    className={`canva-mark ${className}`.trim()}
    style={{ width: size, height: size, fontSize: Math.round(size * 0.45) }}
    aria-hidden
  >
    <span className="canva-mark__inner">C</span>
  </span>
);
